import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  // Desactivar la restauración automática del scroll del navegador
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Restaurar comportamiento por defecto al desmontar (opcional)
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  useEffect(() => {
    // Limpiar cualquier hash en la URL
    if (window.location.hash) {
      window.history.replaceState(null, null, ' ');
    }
    
    // Forzar scroll al inicio inmediatamente
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Segundo intento después de un tick para garantizar
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }, 0);
    
    return () => clearTimeout(timer);
  }, [pathname]);

  // También forzar al montar el componente
  useEffect(() => {
    // Limpiar cualquier hash en la URL al cargar
    if (window.location.hash) {
      window.history.replaceState(null, null, ' ');
    }
    
    // Scroll inmediato al inicio
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Timer de respaldo para asegurar el scroll
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }, 50);
    
    return () => clearTimeout(timer);
  }, []);

  return null;
}

export default ScrollToTop;
